import React, {useCallback, useEffect, useState} from 'react';

import {markNotificationRead} from 'src/openapi/admin/apis/UserInternalNotificationApi';
import {useAppDispatch} from 'src/store/hooks';

import {Dialog} from '@pb/kit-component-dialog-v2';
import {useShown} from '@pb/kit-hooks-use-shown';


import {NOTIFICATION_MODAL_WIDTH, NotificationModal} from './components/notification-modal';

type Props = {
    userId: number,
    notifications: {title: string, notificationId: string}[],
};

export const ActiveNotificationsViewer = ({notifications, userId}: Props) => {
    const {shown, onClick, onClose} = useShown();
    const apiDispatch = useAppDispatch();

    const [readNotifications, setReadNotifications] = useState<string[]>([]);

    useEffect(() => {
        if (notifications.length) {
            onClick();
        }
    }, [notifications, onClick]);

    const markReadNotification = useCallback((id: string) => {
        setReadNotifications(prevState => [
            ...prevState.filter(notificationId => notificationId !== id),
            id,
        ]);
    }, []);

    const closePopup = useCallback(() => {
        onClose();
        readNotifications.forEach(notificationId => {
            apiDispatch(markNotificationRead({notificationId, userId}));
        });
    }, [readNotifications, userId, apiDispatch, onClose]);

    return (
        <Dialog
            shown={shown}
            setShown={closePopup}
            wrapperProps={{style: {width: NOTIFICATION_MODAL_WIDTH}}}>
            <NotificationModal notifications={notifications} onClose={closePopup} onRead={markReadNotification}/>
        </Dialog>
    );
};
